<div class="results-heading">
  <button matIconButton type="button" aria-label="Modifica ricerca" (click)="flow.back()">
    <i class="fa-regular fa-arrow-left" aria-hidden="true"></i>
  </button>
  <div class="results-title">
    <span class="title-medium-emphasized">Risultati ricerca</span>
    <span class="body-large" role="status">{{ countLabel() }}</span>
  </div>

  @if (flow.searchType() === 'ragioneSociale') {
    <button matIconButton type="button" aria-label="Filtri" [attr.aria-expanded]="isMobile() ? null : filtersOpen()" (click)="openFilters()">
      <i [class]="(hasFilters() ? 'fa-solid' : 'fa-regular') + ' fa-filter'" aria-hidden="true"></i>
    </button>
  }
</div>

<div class="step-fields">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ typeLabel() }}</mat-label>
    <input matInput [formControl]="textControl" [attr.inputmode]="flow.searchType() === 'partitaIva' ? 'numeric' : 'text'">
  </mat-form-field>
</div>

@if (!isMobile() && filtersOpen()) {
  <mat-card class="filters-card">
    <ord-new-customer-filters [value]="filtersValue()" [comuniOptions]="comuni()" [provinceOptions]="province()" (applied)="applyFilters($event)" />
  </mat-card>
}

@if (flow.hasExistingCompany()) {
  <ord-new-customer-banner
    title="Cliente già esistente"
    message="Cliente già esistente in Q8, selezionalo per continuare con la proposta d'ordine oppure procedi con una nuova ricerca."
  />
}

@if (flow.hasOtherZoneCompany()) {
  <ord-new-customer-banner
    type="warning"
    title="Cliente già codificato"
    message="La partita IVA associata a questo cliente è già codificata su un'altra zona non di tua competenza. Selezionalo per richiederne la codifica sulla tua zona: la richiesta sarà autorizzata insieme alla proposta d'ordine."
  />
}

@if (flow.companies()?.risultatiOmessi) {
  <ord-new-customer-banner message="Alcuni risultati sono stati omessi perché già codificati" />
}

@if (flow.filteredCompanies().length === 0) {
  <div class="step-empty body-large">Nessuna azienda corrisponde ai filtri</div>
}

<div class="card-list">
  @for (company of flow.filteredCompanies(); track company.companyId) {
    <div class="selectable-card" [class.selectable-card--selected]="isSelected(company)" (click)="select(company)">
      <div class="card-heading card-heading--divided">
        <mat-radio-button
          class="company-radio"
          [checked]="isSelected(company)"
          [attr.aria-label]="'Seleziona ' + company.ragioneSociale"
          (change)="select(company)"
        >
          <span class="body-large-emphasized">{{ company.ragioneSociale }}</span>
        </mat-radio-button>
        @if (company.statoAzienda) {
          <span class="chip chip--success label-small">{{ company.statoAzienda }}</span>
        }
      </div>

      <div class="card-fields">
        <div class="card-field">
          <span class="body-medium-emphasized">Codice Fiscale</span>
          <span class="body-medium">{{ company.codiceFiscale || '—' }}</span>
        </div>
        <div class="card-field">
          <span class="body-medium-emphasized">Partita IVA</span>
          <span class="body-medium">{{ company.partitaIva || '—' }}</span>
        </div>
        <div class="card-field">
          <span class="body-medium-emphasized">Provincia</span>
          <span class="body-medium">{{ company.provincia || '—' }}</span>
        </div>
        <div class="card-field">
          <span class="body-medium-emphasized">Sede legale</span>
          <span class="body-medium">{{ company.sedeLegale || '—' }}</span>
        </div>
      </div>

      <div class="card-footer">
        <button type="button" class="link-button card-link label-medium" (click)="openDetail($event, company)">Vai al dettaglio</button>
      </div>
    </div>
  }
</div>

<div class="results-actions">
  <button matFab extended class="select-floating-button" type="button" [disabled]="!flow.company() || flow.loading()" (click)="confirm()">Seleziona</button>
</div>
